import React, { useContext } from 'react';
import { StyledDiv } from './styles';
import { AppContext } from '../../context/appContext';

const Scrim = () => {
  const [{ isScrimOpen }] = useContext(AppContext);
  return <StyledDiv data-testid="scrim" isOpen={isScrimOpen} />;
};

export default Scrim;
